<script lang="ts" setup>
import NotFound from '@/components/Error/NotFound.vue'
import SomethingWrong from '@/components/Error/SomethingWrong.vue'

import type { NuxtError } from 'nuxt/app'

interface Props {
  error: NuxtError
}

const props = defineProps<Props>()

const errorComponent = computed(() =>
  Number(props.error.statusCode) === 404
    ? markRaw(NotFound)
    : markRaw(SomethingWrong),
)
</script>

<template>
  <NuxtLayout>
    <component :is="errorComponent" />
  </NuxtLayout>
</template>
